import { createLifeomicActionTypes } from '../../util/createActionTypes';

const actions = createLifeomicActionTypes(['SET_MASKED_MODE']);

export default {
  ...actions,
};
